import React from "react";
import { InputLabel, TextField, Autocomplete, Box } from "@mui/material";
import { CountryType } from "~src/data/countries";
import { Chip } from "@mui/material";
import ReactCountryFlag from "react-country-flag";
import { MAINCOUNTRIES} from "~src/data/countries";


const MultiCountrySelect = ({
  onSelect,
  value,
  title,
  countries,
}: {
  onSelect: (value?: string[]) => void;
  value?: string[];
  title?: string;
  countries?: CountryType[];
}) => {
  const [selectedValues, setSelectedValues] = React.useState<string[]>(
    value || ["all"],
  );

  const countryOptions = countries
    ? [{ label: "All", code: "all" }, ...countries]
    : MAINCOUNTRIES;

  React.useEffect(() => {
    setSelectedValues(value || ["all"]);
  }, [value]);

  const handleChange = (
    _event: React.SyntheticEvent<Element, Event>,
    newValues: Array<{ label: string; code: string }>,
  ) => {
    let selectedCountries = newValues.map((option) => option.code);

    // Remove "all" if at least one other country is selected
    if (selectedCountries.length > 1 && selectedCountries.includes("all")) {
      selectedCountries = selectedCountries.filter(
        (country) => country !== "all",
      );
    }

    setSelectedValues(selectedCountries);
    onSelect(selectedCountries.length ? selectedCountries : undefined);
  };

  return (
    <>
      <InputLabel id="media-type-select" sx={{ fontWeight: "bold" }}>
        {title ? title : "Country"}
      </InputLabel>
      <Autocomplete
        multiple
        sx={{ minWidth: "200px", width: "100%" }}
        options={countryOptions}
        getOptionLabel={(option) => option.label}
        value={countryOptions.filter((option) =>
          selectedValues.includes(option.code),
        )}
        onChange={handleChange}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <ReactCountryFlag
              countryCode={option.code === "all" ? "US" : option.code}
              svg
              style={{
                width: "2em",
                height: "2em",
                borderRadius: "7px",
                opacity: option.code === "all" ? 0.5 : 1,
              }}
              title={option.code}
            />
            {option.label}
          </Box>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const tagProps = getTagProps({ index });
            // Extract key to avoid spreading it in props
            const { key, ...chipProps } = tagProps;
            
            return (
              <Chip
                key={key}
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <ReactCountryFlag
                      countryCode={option.code === "all" ? "US" : option.code}
                      svg
                      style={{
                        width: "2em",
                        height: "2em",
                        borderRadius: "7px",
                        opacity: option.code === "all" ? 0.5 : 1,
                      }}
                      title={option.code}
                    />
                    {option.label}
                  </Box>
                }
                {...chipProps}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField {...params} variant="outlined" fullWidth />
        )}
      />
    </>
  );
};

export default MultiCountrySelect;
